import { Component, OnInit } from '@angular/core';
import { ListsService} from '../../services/lists.service';

@Component({
  selector: 'app-lists',
  templateUrl: './lists.component.html',
  styleUrls: ['./lists.component.css']
})
export class ListsComponent implements OnInit {
  selectedList: number = 0;
  selectedListID: number = 0;
  selectedItem: number = 0;
  selectedItemID: number = 0;
  listName: string;
  itemName: string;
  newItemName: string = '';
  editedItem: string = '';
  isAddedItem: boolean = false;
  
  orderedList = -1;

  newList = { 
    settings: 0,
    title: "",
  };

  editedList = {
    id: "",
    settings: 0,
    title: "",
    idUser: localStorage.getItem("idUser"),
    state: 0
  };

  constructor(private listService: ListsService) { }

  ngOnInit() {
    this.listService.getLists();
  }

  addList(){
    if(this.listService.addList(this.newList) == true){
      this.newList.title = "";
    } 
  }

  editList(i){
    this.editedList.id = this.listService.lists[i].id;
    this.editedList.title = this.listService.lists[i].title;
    this.editedList.settings = this.listService.lists[i].settings;

    this.selectedList = i;
  }

  updateList(){
    this.listService.updateList(this.editedList, this.selectedList);
  }

  removeList(i, id){
    this.listService.removeList(i, id);
    
  }

  dropSuccess(i){
    this.orderedList = -1;
    this.listService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedList = i;
  }

  dragEnd(){
    this.orderedList = -1;
  }

  orderUp(i){
    this.listService.orderUp(i);
  }
  orderDown(i){
    this.listService.orderDown(i);
  }
} 



// WEBPACK FOOTER //
// ./src/app/components/lists/lists.component.ts